import _merge from 'lodash/merge';
import { Lightning } from '@lightningjs/sdk';
import { MetadataTitle } from './components/metadataTitle.component';
import { getInitialStyle, defaultContext } from './metadata.style';

export class Metadata extends Lightning.Component {
  static _template() {
    return _merge(
      {
        Title: {
          type: MetadataTitle,
        },
        ExtraTitle: {},
      },
      getInitialStyle(),
    );
  }

  _build() {
    this._style = defaultContext;
  }

  _updatePositions() {
    const extraTitle = this.tag('ExtraTitle');
    const offset = this.finalH;

    if (extraTitle.visible) {
      extraTitle.y = offset;
    }
  }

  get title() {
    return this.tag('Title').title;
  }

  set title(value) {
    const element = this.tag('Title');
    element.title = value;
    element.visible = Boolean(value);
    this._updatePositions();
  }

  get extraTitle() {
    return this.tag('ExtraTitle').text.text;
  }

  set extraTitle(value) {
    const element = this.tag('ExtraTitle');
    element.text.text = value;
    element.visible = Boolean(value);
    this._updatePositions();
  }
}
